import React, { Component } from 'react';

import { StringUtils, ValidatorUtils } from '../utils';
import { Routes as routes } from '../navigation';
import { Button, Input, Errors, Header } from '../components';
import Spinner from 'react-bootstrap/Spinner'
import '../css/UserProfile.css';

class UserChangePassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      confirm_password: '',
      confirm_password_invalid: false,
      display_password_rules: false,
      loading_login: false,
      validation: {},
    }
  }

  renderLoginInfoSection = () => {
    let loading = this.state.loading_login;
    let user    = this.props.user || {};
    let email   = user.email || '';
    let is_edit = this.state.display_edit_email || this.state.display_edit_password;

    if (!is_edit) {
      return <div className='flex-container-column' style={{ padding: 15, paddingTop: 10, paddingLeft: 20, fontSize: 14 }}>
        <div style={{ fontSize: 15, color: '#575757' }}>Edit your login email or password</div>
        <div className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
          <span style={{ color: 'grey' }}>{ email }</span>
          <div className='instant-cancel-button'
               style={{ marginRight: 5, color: '#1dc2ff', fontWeight: 'bold' }}
               onClick={ () => { this.setState({ ...this.state, display_edit_email: true }) }}>
            <span className='fas fa-edit' />
          </div>
        </div>
        <div className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'space-between', marginTop: 10 }}>
          <span style={{ color: 'grey' }}>{ 'Password' }</span>
          <div className='instant-cancel-button'
               style={{ marginRight: 5, color: '#1dc2ff', fontWeight: 'bold' }}
               onClick={ () => { this.setState({ ...this.state, display_edit_password: true }) }}>
            <span className='fas fa-edit' />
          </div>
        </div>
      </div>
    }

    return <div className='flex-container-column' style={{ paddingBottom: 15, paddingTop: 5 }}>

    { this.state.display_edit_email
    ? <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 10 }}>
        <Input placeholder="New Email"
               value={this.state.email}
               className='instant-input-default'
               invalid={this.state.email_invalid}
               style={{ flex: 1, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
              />
        <Input placeholder="Confirm Email"
               value={this.state.confirm_email}
               className='instant-input-default'
               invalid={this.state.confirm_email_invalid}
               style={{ flex: 1, marginLeft: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, confirm_email: event.target.value }) }}
              />
      </div> : null }

      { this.state.display_edit_password
      ? <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 5 }}>
        <Input placeholder="New Password"
               value={this.state.password}
               className='instant-input-default'
               invalid={this.state.password_invalid}
               style={{ flex: 1, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, password: event.target.value }) }}
               type='password'
              />
        <Input placeholder="Confirm Password"
               value={this.state.confirm_password}
               className='instant-input-default'
               invalid={this.state.confirm_password_invalid}
               style={{ flex: 1, marginLeft: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, confirm_password: event.target.value }) }}
               type='password'
              />
      </div> : null }
      { this.state.display_edit_password
        ? <span style={{ fontSize: 12, marginTop: 5, marginLeft: 17, color: 'grey' }}>8 chars or more & containing one of each: a-z A-Z 0-9 @$!%*?</span> : null }

      <div className='flex-container-row' style={{ justifyContent: 'flex-end', marginTop: 15, paddingRight: 15, fontSize: 13 }}>
        <div className='instant-cancel-button'
             style={{ marginRight: 5, color: '#1dc2ff', fontWeight: 'bold' }}
             onClick={ () => { this.cancelLoginChanges() }}>
          <span>Cancel</span>
        </div>
        <div className='instant-join-session-button'
             style={{ fontSize: 13 }}
             onClick={ () => {
               let process_email = this.state.password === '' && this.state.email !== '';
               let process_pswd  = this.state.email    === '';
               if (process_email) {
                 this.processEmailChange();
               }
               if (process_pswd) {
                 this.processPasswordChange();
               }

             }}>
          { loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white' }} />
                    : <span className='fas fa-check' style={{ fontSize: 16 }} /> }
          <span style={{ marginLeft: 8 }}>Save Changes</span>
        </div>
      </div>

    </div>
  }

  renderUserChangePassword = (user) => {
    if (!user) {
      return null
    }

    return <div className="standard-container">
      <Header icon='fas fa-sign-in-alt' title='Login Email & Password' />

      { this.renderLoginInfoSection() }

    </div>
  }

  render() {
    return this.renderUserChangePassword(this.props.user);
  }

  processEmailChange = () => {
    let token = this.props.token;
    let user  = this.props.user;
    let email = user.email || '';

    let new_email = this.state.email;

    if (!new_email || !this.state.confirm_email) {
      this.setState({ ...this.state, email_invalid: new_email === '', confirm_email_invalid: this.state.confirm_email === '' })
    }

    if (new_email !== this.state.confirm_email) {
      this.props.toastActions.displayError('Email and Confirm Email do not match')
      this.setState({ ...this.state, email_invalid: false, confirm_email_invalid: true })
    }

    if (token && user && new_email && new_email === this.state.confirm_email) {
      let user_data = {
        _id: user._id,
        email: new_email
      }
      this.setState({ ...this.state, loading_login: true })
      this.props.userActions.editUser(token, user_data, this.emailCallback);
    }
  }

  processPasswordChange = () => {
    let token = this.props.token;
    let user  = this.props.user;
    let email = user.email || '';

    let new_password = this.state.password;
    let confirm_pwd  = this.state.confirm_password;

    let password_validation = ValidatorUtils.validatePassword(new_password, confirm_pwd);

    if (password_validation.message !== '') {
      this.props.toastActions.displayError(password_validation.message);
      this.setState({ ...this.state, display_password_rules: password_validation.strength_error, password_invalid: password_validation.password_invalid, confirm_password_invalid: password_validation.confirm_password_invalid })
      return;
    }

    if (token && email && new_password) {
      this.setState({ ...this.state, loading_login: true })
      this.props.userActions.changeUserPassword(token, email, new_password, this.emailCallback);
    }
  }

  emailCallback = () => {
    this.setState({
      ...this.state,
      email: '',
      confirm_email: '',
      confirm_email_invalid: false,
      email_invalid: false,
      display_edit_email: false,
      display_edit_password: false,
      password_invalid: false,
      confirm_password_invalid: false,
      display_password_rules: false,
      loading_login: false,
      display_password_rules: false,
      password: '',
      confirm_password: '',
    })
  }

  cancelLoginChanges = () => {
    this.setState({
      ...this.state,
      email: '',
      confirm_email: '',
      password: '',
      confirm_password: '',
      email_invalid: '',
      confirm_email_invalid: '',
      password_invalid: '',
      confirm_password_invalid: '',
      display_edit_email: false,
      display_edit_password: false,
      loading_login: false,
      display_password_rules: false,
    })
  }

}


export default UserChangePassword
